import { IconPresensiMasuk, IconPresensiPulang } from "../../../assets";

const ItemJadwal = ({ hari, tgl, jadwal_masuk, jadwal_pulang }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 border-l-4 mt-3 px-4 py-3"
      style={{ borderLeftColor: "#FFB703" }}
    >
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-bold text-gray-800">{hari}</span>
        <span className="text-xs font-medium px-2.5 py-1 rounded-full" style={{ backgroundColor: "#FFF3CD", color: "#92400E" }}>
          {tgl}
        </span>
      </div>

      <div className="flex gap-3">
        <div className="flex-1 flex items-center gap-2 bg-green-50 rounded-xl px-3 py-2">
          <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center shrink-0">
            <img src={IconPresensiMasuk} alt="masuk" style={{ width: 18, height: 18 }} />
          </div>
          <div>
            <p className="text-xs text-gray-400">Masuk</p>
            <p className="text-sm font-bold text-gray-800">{jadwal_masuk}</p>
          </div>
        </div>

        <div className="flex-1 flex items-center gap-2 bg-orange-50 rounded-xl px-3 py-2">
          <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center shrink-0">
            <img src={IconPresensiPulang} alt="pulang" style={{ width: 18, height: 18 }} />
          </div>
          <div>
            <p className="text-xs text-gray-400">Pulang</p>
            <p className="text-sm font-bold text-gray-800">{jadwal_pulang}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemJadwal;
